import { render, staticRenderFns } from "./logoSistema.vue?vue&type=template&id=860bc81c"
import script from "./logoSistema.vue?vue&type=script&lang=js"
export * from "./logoSistema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports